<template>
  <transition name="slide-fade">
    <div id="aboutusHolder">
      <!--<div class=" uk-background-secondary uk-light" style="padding: 20px; color: rgb(197,179,88) !important;">
        <div class="uk-container uk-container-small">
          <p class="uk-text-center uk-text-lead@l uk-text-large@l">
            <i>"Handling and securing your finances with care and understanding"</i>
          </p>
        </div>
      </div>-->
      <div class="uk-padding">
        <h1 class="uk-heading-line specHeading uk-text-center"><span>Student Finance</span></h1>
        <div class="uk-container uk-container-small">
          <div class="uk-child-width-1-2@m" uk-grid>
            <div>
              <p class=" ">
                The department of Student Finance seeks to help and guide students with their finances for the duration of their time at Northern Caribbean University.
                The department takes a number of roles to serve students that include:
              </p>
              <ul class="uk-list uk-list-bullet uk-text-small">
                <li>Prepare fee schedules (Tuition Estimates/Invoices)</li>
                <li>Facilitate completion of registration (Financial Registration) both in office and online.</li>
                <li>Process requests for transfer of funds between accounts. <span class="uk-text-primary">Conditions apply.</span></li>
                <li>Maintaining all students’ accounts</li>
              </ul>
            </div>
            <div class="uk-visible@m">
              <img class="uk-align-center" src="../assets/ss.jpeg" >
            </div>
          </div>


        </div>
      </div>
      <div class="uk-padding uk-background-muted">
        <div class="uk-container uk-container-small">
          <h2 class="uk-heading-bullet specHeading"><span>Procedures</span></h2>
          <div uk-grid>
            <div class="uk-width-auto@m">
              <ul class="uk-tab-left" uk-tab="connect: #component-tab-left1; animation: uk-animation-fade">
                <li><a href="#">Payment of Application Fee</a></li>
                <li><a href="#">Payment of Pre-Acceptance Deposits</a></li>
                <li><a href="#">Payment of Library Fines</a></li>
                <li><a href="#">Payment for I.D Card Replacement</a></li>
                <li><a href="#">Cheque Requisition</a></li>
                <li><a href="#">Graduation Clearance</a></li>
                <li><a href="#">Transfer Credit</a></li>
                <li><a href="#">Withdrawal of Funds</a></li>
                <li><a href="#">Withdrawal from University</a></li>
                <li><a href="#">Registration Fees</a></li>
                <li><a href="#">Registration for Returning Students</a></li>
                <li><a href="#">Changes in Registration</a></li>
                <li><a href="#">Students with the Student Loan Bureau</a></li>
                <li><a href="#">Granting Discounts</a></li>

              </ul>
            </div>
            <div class="uk-width-expand@m">
              <ul id="component-tab-left1" class="uk-switcher">
                <li>
                  <h3 class="specHeading uk-heading-bullet">Payment of Application Fee</h3>
                  A student shall pay the application fee when he/she applies for admission to the University (NCU Bulletin, p. 11).
                  The application fee for a student:
                  <br><br>
                  <div class="uk-child-width-1-2@m" uk-grid>
                    <div>
                      <h4 class="uk-heading-bullet specHeading">Undergraduate</h4>
                      <ul class="uk-list uk-list-bullet">

                        <li>J$1000 (Local Students)</li>
                        <li>US$55 (International Students)</li>
                        <li>US$30 (West Indies Union Students)</li>
                      </ul>
                    </div>
                    <div>
                      <h4 class="uk-heading-bullet specHeading">Graduate</h4>
                      <ul class="uk-list uk-list-bullet"><br>

                        <li>J$2,500 (Local Students) - Post-graduate Diploma & Masters </li>
                        <li>US$30.00 (International Students) - Post-graduate Diploma &amp; Masters</li>
                        <li>J$3,500.00 (Local Students) - Doctoral</li>
                        <li>US$50.00 (International Students) - Doctoral</li>
                      </ul>
                    </div>
                  </div>

                </li>
                <li>
                  <h3 class="specHeading uk-heading-bullet">Payment of Pre-Acceptance Deposits</h3>
                  <ul class="uk-list uk-list-bullet ">
                    <li>All new students shall be required to make a cash deposit before receiving their letter of
                      acceptance (NCU Bulletin, p. 13).</li>
                    <li>The deposit shall be held as security until students sever their connection with the
                      University, at which time, they shall receive a full refund, provided no outstanding bills
                      remain (NCU Bulletin, p. 14).</li>
                    <li>
                      Details regarding deposits shall be made available from Financial Affairs (NCU Bulletin,
                      p. 14).
                    </li>
                  </ul>


                </li>
                <li>
                  <h3 class="specHeading uk-heading-bullet">Payment of Library Fines</h3>
                  <ul class="uk-list uk-list-bullet ">
                    <li>All fines imposed by the University Library shall become due to the University and shall
                      be paid at the Business Office (NCU Bulletin, p. 12).
                    </li>
                    <li>
                      After payment, the receipt shall be taken to the circulation desk at the Library (NCU
                      Bulletin, p. 12).
                    </li>
                    <li>
                      Fines shall be imposed for the late return of books, lost or damaged books or other related
                      charges as specified by the Library (NCU Bulletin, p. 12).
                    </li>
                  </ul>
                </li>
                <li>
                  <h3 class="specHeading uk-heading-bullet">Payment for I.D Card Replacement</h3>
                  <ul class="uk-list uk-list-bullet ">
                    <li>
                  Each student shall receive an identification card at no charge, which certifies that he/she
                      is enrolled as a student at the University (Tuition and Fees Webpage).</li>
                    <li>
                  If a student has lost his/her identification card, he or she shall pay a non-refundable fee of
                  $1000 for replacement.
                    </li>
                  </ul>
                </li>
                <li>
                  <h3 class="specHeading uk-heading-bullet">Cheque Requisition</h3>
                  <ul class="uk-list uk-list-bullet ">
                    <li>
                      Students who need funds from their account for personal use may request through cheque
                      requisition.</li>
                    <li>
                      Students who are eligible for requesting cheque requisition are those whose tuition are
                      paid by sponsors.</li>
                    <li>
                      Students who are beneficiaries of the Student Loan, JAMVAT or the National Youth
                      Service are not eligible for requesting cheque requisition unless they have funds from
                      other source(s) on their account.</li>
                    <li>
                      After the application for a cheque requisition is made by the student, the money is
                      deposited in the student’s account on the fifteenth (15 th ) and thirtieth (30 th ) of the month.
                    </li>
                  </ul>
                </li>
                <li>
                  <h3 class="specHeading uk-heading-bullet">Graduation Clearance</h3>
                  <ul class="uk-list uk-list-bullet ">
                    <li>
                      After the prospective graduate list is published from the Office of University Records, the
                      department of Student finance shall search for the security deposit of each prospective
                      graduate.</li>
                    <li>
                      The security deposit shall be credited to the student’s account.</li>
                    <li>
                      Personnel from the department of Student Finance shall check all prospective graduates’
                      accounts to ensure all outstanding fees have been paid. This is done during the gown
                      collection process.</li>
                    <li>
                      After commencement, Student finance is one of the signatures on the Graduation
                      Clearance Form.
                    </li>
                  </ul>
                </li>
                <li>
                  <h3 class="specHeading uk-heading-bullet">Transfer Credit</h3>
                  <ul class="uk-list uk-list-bullet ">
                    <li>
                      Students may transfer funds from his/her account to another student’s account or an
                      entity’s account.</li>
                    <li>
                      A Transfer of Credit form must be completed by the student.</li>
                    <li>
                      The transfer of credit shall take a maximum of two (2) days to reach the receiving
                      account.</li>

                  </ul>
                </li>
                <li>
                  <h3 class="specHeading uk-heading-bullet">Withdrawal of Funds</h3>
                  <ul class="uk-list uk-list-bullet ">
                    <li>
                      Cash paid in advance on students’ accounts shall not be withdrawn without the written
                      permission of the individual or organization which originally made the payments (NCU
                      Bulletin, p. 14).</li>
                    <li>
                      Genuine emergencies shall be given consideration when accounts show consistent credit
                      balances (NCU Bulletin, p. 14).</li>


                  </ul>
                </li>
                <li>
                  <h3 class="specHeading uk-heading-bullet">Withdrawal from University</h3>
                  <ul class="uk-list uk-list-bullet ">
                    <li>
                      When a student withdraws during a semester for whatever reason, the semester’s charge
                      for boarding becomes due and payable (NCU Bulletin, p. 14).</li>
                    <li>
                      Refund on deposits is issued only after a final statement for the student shall become
                      available (NCU Bulletin, p. 14).</li>
                    <li>
                      Payment shall be expected thirty (30) to forty-five (45) days after the student leaves the
                      University (NCU Bulletin, p. 14).
                    </li>
                    <li>
                      The sum to be refunded will be calculated only on Tuition and applicable lab charges <br> <br>
                      <router-link to="/tuitionfees" class="uk-button uk-button-default">See Tuition & Fess</router-link>
                    </li>
                  </ul>
                </li>
                <li>
                  <h3 class="specHeading uk-heading-bullet">Registration Fees</h3>
                  <ul class="uk-list uk-list-bullet ">
                    <li>
                      A student shall pay all fees at registration (NCU Bulletin, p. 13).</li>
                    <li>
                      A student shall not be officially enrolled until fees or payment arrangements are made
                      through the office of Financial Affairs (NCU Bulletin, p. 12).</li>
                    <li>
                      All students shall be charged general fees (NCU Bulletin, p. 12).
                    </li>
                    <li>
                      Students taking a major or minor in Music and taking Applied Music shall be charged
                      according to a special schedule (NCU Bulletin, p. 12).
                    </li>
                    <li>
                      Students pursuing the following courses shall be required to pay fees in order to pay for
                      the use of laboratories (NCU Bulletin, p. 13). These disciplines are Biology, Chemistry, Medical Technology,
                      Physics, Nutrition and Hospitality Management, Mass Communication, Information Science, Nursing, Dental Hygiene, Business Administration
                    </li>
                    <li>
                      Students who major in Education shall be required to pay the Teacher External
                      Examination exam fee (NCU Bulletin, p. 13).
                    </li>
                    <li>
                      A student shall pay fees at any of the following locations:
                      <ul class="uk-list uk-list-divider ">
                        <li>Any Pay master or Bill Express</li>
                        <li>Any Bank of Nova Scotia (BNS) branch or Scotia online payment</li>
                        <li>Any National Commercial Bank (NCB) branch or online payment</li>
                        <li>The NCU Cashier from Monday through Thursday, 8:15 a.m. to 4:00 p.m; Fridays
                          from 8:15 a.m. to 1:00 p.m)</li>
                        <li>
                          Online through the university’s website using Visa Cards (Local & International)
                          and Master Cards (Local & International)
                        </li>
                      </ul>
                    </li>
                    <li>
                      If a student choses to settle an account by mail, following the guidelines on cheques,
                      letters shall be addressed to the Director of Student Finance, Northern Caribbean
                      University, Manchester Road, Mandeville, Jamaica WI (NCU Bulletin, p. 13)
                    </li>
                    <li>
                      All fees shall be subject to change by the Northern Caribbean University Board of
                      Trustees (NCU Bulletin, p. 10).
                    </li>
                    <li>
                      Students shall be registered for courses as their sources of funding dictate (NCU Bulletin,
                      p. 14) and as such are liable for all fees associated with all courses for which they are
                      registered at the end of the add/drop period.
                    </li>
                    <li>
                      If fees are not paid in full by the end of the contract period, all courses shall be subject to
                      cancellation and any money paid to the University shall be lost (NCU Bulletin, p. 14).
                    </li>
                    <li>
                      A student who begins registration, but fails to complete it and then withdraws, shall be
                      charged a handling fee equivalent to the general fee.
                    </li>
                    <li>
                      Students who do not complete registration during the registration period shall be charged
                      $1000 on the first day and thereafter on each additional day unto two weeks after the
                      semester has begun.
                    </li>
                  </ul>
                </li>
                <li>
                  <h3 class="specHeading uk-heading-bullet">Registration for Returning Students</h3>
                  <ul class="uk-list uk-list-bullet ">
                    <li>
                      Returning students shall register for classes online using the Aeorion Learning
                      Management System providing they have paid at least fifty percent (50%) of the tuition.</li>
                    <li>
                      If the student does not have at least fifty percent (50%) of the tuition in his or her
                      account, then the student must physically register at the Student Finance office.</li>
                    <li>
                      Once the student has selected the courses for registration, he or she shall come into the
                      Student Finance Office before or during the assigned registration period.
                    </li>
                    <li>
                      The student finance representative shall upon confirming the registered courses and the
                      financial status of the students activate the registration by selecting that option on the
                      Aeorion Learning Management System.
                    </li>
                    <li>
                      The student finance representative shall print a verification of the courses registered for
                      and the total cost of tuition.
                    </li>
                    <li>
                      This verification print out shall be printed in duplicates. One copy shall be signed by the
                      student finance representative, stamped and given to the student for his/her keeping; the
                      other copy shall be filed by the student finance representative.
                    </li>
                    <li>
                      After activation of registration, the student’s name shall appear on the class lists and
                      his/her profile status on the AEorion LMS shall state “registered.”
                    </li>
                  </ul>
                </li>
                <li>
                  <h3 class="specHeading uk-heading-bullet">Changes in Registration</h3>
                  <ul class="uk-list uk-list-bullet ">
                    <li>
                      A student shall make changes in his/her registration by using the add/drop procedure or
                      change of section procedure.</li>
                    <li>
                      The student shall add or drop courses using the AEorion LMS or manually by completing
                      the Add/drop form collected at the Office of University Records.</li>
                    <li>
                      The Student Finance representative shall check the list of students who have
                      applied for add/drop each day.
                    </li>
                    <li>
                      The student Finance representative shall approve or deny the applications for add/drop
                      online based on the status of the student’s account.
                    </li>
                    <li>
                      The student Finance representative shall make the necessary changes to the student’s
                      account.
                    </li>
                    <li>
                      Student Finance is not involved in the dropping of courses.
                    </li>

                  </ul>
                </li>
                <li>
                  <h3 class="specHeading uk-heading-bullet">Students with the Student Loan Bureau</h3>
                  <ul class="uk-list uk-list-bullet ">
                    <li>
                      The Student Finance Department shall ensure that students who have applied for student
                      loans from the Student Loan Bureau have completed the requisite loan application forms.</li>
                  </ul>
                </li>
                <li>
                  <h3 class="specHeading uk-heading-bullet">Granting Discounts</h3>
                  <ul class="uk-list uk-list-bullet ">
                    <li>
                      If one person is responsible for the tuition of two persons from the same family, a
                      discount of five per cent (5%) shall be given (NCU Bulletin, p. 13).</li>
                    <li>
                      If one person is responsible for the tuition of three or more children, a ten per cent (10%)
                      discount shall be given (NCU Bulletin, p. 13).
                    </li>
                    <li>
                      Students who permanently reside in Jamaica and Atlantic Caribbean Union who hold
                      church membership in any Seventh-day Adventist church within these territories, shall
                      receive a ten percent (10%) discount on tuition fees at registration (Tuition and Fees
                      Website).
                    </li>
                    <li>
                      Discounts shall not be retroactive and shall be granted only to those whose accounts are
                      kept in balance (NCU Bulletin, p. 13).
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

    </div>
  </transition>
</template>

<script>
    export default {
        name: "finance",
      mounted(){
        window.scrollTo(0, 0);
      },
      metaInfo: {
        // Children can override the title.
        title: 'NCU Student Finance',
        // Result: My Page Title ← My Site
        // If a child changes the title to "My Other Page Title",
        // it will become: My Other Page Title ← My Site
        //titleTemplate: '%s ← My Site',
        // Define meta tags here.
        meta: [
          {'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8'},
          {name: 'viewport', content: 'width=device-width, initial-scale=1'},
          {name: 'description', content: 'Department of Student Finance  at Northern Caribbean University '}
        ]
      }
    }
</script>

<style scoped>

</style>
